import { useAtomValue } from 'jotai';

export default function CheckboxFilterLabel({ label, isFilterActiveAtom, checkedValuesAtom }) {
  const checkedValues = useAtomValue<string[]>(checkedValuesAtom);
  const filterActive = useAtomValue(isFilterActiveAtom);
  return filterActive && checkedValues.length === 1 ? checkedValues[0] : label;
}
